import { HttpMethod_PATCH_getInstance2444xhczsg6ri as HttpMethod_PATCH_getInstance } from '../../../../kiteui-library/com/lightningkite/kiteui/fetch.mjs';
import { Companion_getInstance3n9as6ds1py67 as Companion_getInstance } from '../../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
import { ListSerializer1hxuk9dx5n9du as ListSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Companion_getInstance1an2l1q3snzzy as Companion_getInstance_0 } from '../../../../crowpay-shared/com/crowpay/readReceipts.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var HasReadByEndpointsLiveClass;
function HasReadByEndpointsLive() {
  if (HasReadByEndpointsLiveClass === VOID) {
    class $ {
      constructor(fetcher, subpath, serializer) {
        this.qf9_1 = fetcher;
        this.rf9_1 = subpath;
        this.sf9_1 = serializer;
      }
      tf9(input, $completion) {
        return this.qf9_1.fei(this.rf9_1 + '/mark-read', HttpMethod_PATCH_getInstance(), ListSerializer(Companion_getInstance().m2a()), input, ListSerializer(this.sf9_1), $completion);
      }
    }
    initMetadataForClass($, 'HasReadByEndpointsLive', VOID, VOID, VOID, [1]);
    HasReadByEndpointsLiveClass = $;
  }
  return HasReadByEndpointsLiveClass;
}
var HasReadByWithFeedbackEndpointsLiveClass;
function HasReadByWithFeedbackEndpointsLive() {
  if (HasReadByWithFeedbackEndpointsLiveClass === VOID) {
    class $ extends HasReadByEndpointsLive() {
      xf9(input, $completion) {
        return this.qf9_1.fei(this.rf9_1 + '/mark-feedback-read', HttpMethod_PATCH_getInstance(), ListSerializer(Companion_getInstance().m2a()), input, ListSerializer(this.sf9_1), $completion);
      }
    }
    initMetadataForClass($, 'HasReadByWithFeedbackEndpointsLive', VOID, VOID, VOID, [1]);
    HasReadByWithFeedbackEndpointsLiveClass = $;
  }
  return HasReadByWithFeedbackEndpointsLiveClass;
}
var HasReadByWithCreditsEndpointsLiveClass;
function HasReadByWithCreditsEndpointsLive() {
  if (HasReadByWithCreditsEndpointsLiveClass === VOID) {
    class $ extends HasReadByEndpointsLive() {
      bfa(input, $completion) {
        return this.qf9_1.fei(this.rf9_1 + '/mark-credits-read', HttpMethod_PATCH_getInstance(), Companion_getInstance_0().m2a(), input, ListSerializer(this.sf9_1), $completion);
      }
    }
    initMetadataForClass($, 'HasReadByWithCreditsEndpointsLive', VOID, VOID, VOID, [1]);
    HasReadByWithCreditsEndpointsLiveClass = $;
  }
  return HasReadByWithCreditsEndpointsLiveClass;
}
//region block: exports
export {
  HasReadByEndpointsLive as HasReadByEndpointsLive3vmvwhttt3ssi,
  HasReadByWithCreditsEndpointsLive as HasReadByWithCreditsEndpointsLive17nkdcbe2canp,
  HasReadByWithFeedbackEndpointsLive as HasReadByWithFeedbackEndpointsLive1r08wwk6n4a50,
};
//endregion

//# sourceMappingURL=HasReadByEndpointsLive.mjs.map
